<!-- (1) IF USER IS NOT SIGNED IN & NOT SUBSCRIBED-->
<!-- <CallToActionJoin /> shows 'Get Notified' button  -->
<!-- Clicking on <CallToActionJoin /> adds #join to URL -->
<!-- This triggers <AppModalJoin> to mount <AppModalIFrame> -->
<!-- This opens fullstack.vizbi.org/transparent#join -->
<!-- (2) IF USER IS SIGNED IN & NOT SUBSCRIBED-->
<!-- <CallToActionJoin /> shows 'Join Our Community' button  -->
<!-- Clicking button adds #subscribe to URL -->
<!-- This triggers <AppModalJoin> to mount <AppModalIFrame> -->
<!-- This opens fullstack.vizbi.org/transparent#subscribe, full-window -->
<!-- (3) IF USER IS SIGNED IN & SUBSCRIBED-->
<!-- <CallToAction /> banner is hidden  -->
<!-- <MailingList /> button is shown  -->
<!-- Clicking the button triggers <AppModalSubscribe> to mount <AppModalIFrame> -->
<!-- This opens fullstack.vizbi.org/transparent#subscribe, full-window -->

<!-- your_email+clerk_test@example.com  |  test code: 424242 -->

<template>
  <a v-if="!isSignedIn" href="#sign-in" target="_self">{{ label || "Join Our Community" }}</a>
  <a v-else href="#sign-in" target="_self">{{ label || "Stay Informed" }}</a>
  <!-- <a v-else-if="isSignedIn && !isSubscribed" href="#subscribe" target="_self">Stay Informed</a> -->
</template>

<script setup>
import useUserSafe from "@/composables/useUserSafe";
defineProps({label: {type: String, default: ""}});
const {isSignedIn} = useUserSafe();
</script>

<style scoped>
a {
  /* font-size: 1.73rem; */
  white-space: nowrap;
  font-weight: bold;
  color: white;
  background-color: var(--brand-color);
  padding: 0.6rem 2.3rem;
  border-radius: 17px; /* Example value to increase rounded corners */
}
.narrow a {
  padding: 0.6rem 0.8rem;
}
/* Button-like styling for anchor tags */
a {
  text-align: center; /* Center the text inside the button */
  text-decoration: none; /* Removes underline from links */
  border: none; /* Removes border */
  cursor: pointer; /* Changes the cursor to indicate clickable items */
}

/* Hover effect */
:is(a:hover, a:focus) {
  color: white;
  background-color: var(--brand-hover-color); /* Darkens */
  text-decoration: none; /* Ensures text remains not underlined on hover */
  outline: none; /* Removes outline to keep the design clean */
}
/* Active (click) effect */
a:active {
  background-color: var(--brand-hover-color); /* darken */
}
.isSubscribed {
  background-color: red;
}
</style>
